function getTableFilterValue(isMulti, type, event) {
  if (["picklist", "select", "statusbadge"].includes(type)) {
    if (isMulti) {
      if (event.filter((e) => e.label).length > 0) {
        //It is assumed if the event has a label, then its got a value)
        return event.filter((e) => e.label).map((e) => e.value); //This is because if e.value was = 0, then it wouldn't count it in the filter
      } else {
        return "";
      }
    } else {
      return event ? event.value : "";
    }
  }

  return event.target.value;
}

export { getTableFilterValue };
